<tui-root>
  <router-outlet></router-outlet>
  <rec-toast-container></rec-toast-container>
</tui-root>
